<template>
    <v-container>
        <v-flex class="travels-from">
            <h4>{{ SpeakerApplicants.TRAVELS_FROM_COUNTRY }}</h4>
            <v-flex pb-3>
                <v-flex class="form-control" v-if="countries">
                    <v-chip v-if="countryFilter.length > 0" close @input="removeCountry">
                        {{ countryFilter }}
                    </v-chip>
                    <v-select
                        class="mt-1"
                        data-qe-id="country-filter_drop_down"
                        :items="Object.values(countries).sort()"
                        v-model="countryFilter"
                        @change="countryChange()"
                    >
                    </v-select>
                </v-flex>
                <v-flex class="form-control relative-position">
                    <h4>{{ SpeakerApplicants.TRAVELS_FROM_CITY }}</h4>
                    <v-chip
                        v-for="(city, index) in cityFilter"
                        :key="index"
                        :data-qe-id="`selected-topics_index_${index}`"
                        close
                        @input="removeCity(index)"
                    >
                        {{ city }}
                    </v-chip>
                    <v-text-field
                        class="filter-options__typeAhead__input"
                        hide-details
                        @keyup="getTypeAheadResult"
                        v-model="cityTypeAhead"
                    ></v-text-field>
                    <v-layout
                        column
                        class="filter-options__typeAhead-result inner-scrollbar"
                        v-if="cityTypeAhead && cityTypeAhead.length > 2"
                    >
                        <status-overlay :action="typeAheadAction" content-height="60px"></status-overlay>
                        <v-flex
                            xs4
                            class="filter-options__typeAhead-result--item"
                            v-for="(searchItem, index) in typeAheadCityResult.result"
                            :key="index"
                        >
                            <label class="check-container ypo_blue_color">
                                <v-label @click="onCitySelected(searchItem.label)">{{ searchItem.label }}</v-label>
                                <span class="checkmark"></span>
                            </label>
                        </v-flex>
                        <v-flex xs4 pa-2 v-if="showNoResult" class="bold-font ypo_blue_color">
                            {{ SpeakerApplicants.NO_RESULT_FOUND }}
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-flex>
        </v-flex>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { storeAction } from '../../store/storeActions.constant';
import { SpeakerApplicants } from '../Speakers/speakerConstant';
import StatusOverlay from '../../components/StatusOverlay/StatusOverlay';

export default {
    name: 'SearchSpeakerTravelsFrom',
    data: () => ({
        SpeakerApplicants,
        cityTypeAhead: '',
        countryFilter: '',
        typeAheadCityResult: [],
        cityFilter: [],
        timeoutForTypeAhead: null,
        showNoResult: false,
    }),
    props: {
        applySpeakerFilter: {
            type: Function,
            required: true,
        },
        countries: {
            type: Array,
            required: true,
        },
    },
    created() {
        this.checkSpeakersCountryFilter();
        this.checkSpeakersCityFilter();
    },
    components: {
        StatusOverlay,
    },
    methods: {
        ...mapActions({
            initiateSpeakerTypeAheadSearch: `searchSpeaker/${storeAction.initiateSpeakerTypeAheadSearch}`,
        }),
        countryChange() {
            this.$router.push({
                query: {
                    ...this.$route.query,
                    country: this.countryFilter,
                },
            });
        },
        getTypeAheadResult() {
            this.typeAheadCityResult.result = [];
            this.showNoResult = false;
            clearTimeout(this.timeoutForTypeAhead);
            if (this.cityTypeAhead.length > 2) {
                this.timeoutForTypeAhead = setTimeout(() => {
                    this.timeoutForTypeAhead = null;
                    const typeAheadObject = {
                        search: this.cityTypeAhead,
                        additionalFilters: null,
                        fieldsToQuery: ['CombinedCity'],
                        searchFilters: [],
                        typeaheadPreFilter: this.countryFilter.length
                            ? {
                                  filterKey: 'CombinedCountry',
                                  filterValue: this.countryFilter,
                                  label: this.countryFilter,
                              }
                            : null,
                    };
                    this.initiateSpeakerTypeAheadSearch(typeAheadObject).then((response) => {
                        this.typeAheadCityResult = response;
                        this.showNoResult = response.result.length === 0;
                    });
                }, 1000);
            }
        },
        onCitySelected(city) {
            if (city) {
                this.cityFilter.push(city);
            }
            this.$router.push({
                query: {
                    ...this.$route.query,
                    city: this.cityFilter.join('~'),
                },
            });
        },
        removeCity(index) {
            this.cityFilter.splice(index, 1);
            this.onCitySelected();
        },
        removeCountry() {
            this.$router.push({
                query: {
                    ...this.$route.query,
                    country: '',
                },
            });
        },
        checkSpeakersCountryFilter() {
            if (this.$route.query.country && this.$route.query.country.length) {
                const value = this.$route.query.country;
                this.countryFilter = value;
                this.applySpeakerFilter([
                    {
                        label: 'Country',
                        filterKey: 'Country',
                        filterValue: value,
                    },
                ]);
            }
        },
        checkSpeakersCityFilter() {
            if (this.$route.query.city && this.$route.query.city.length) {
                const value = this.$route.query.city.split('~');
                this.cityFilter = value;
                this.applySpeakerFilter(value.map(item => ({
                        label: 'TravelsFromCity',
                        filterKey: 'TravelsFromCity',
                        filterValue: item,
                    })),);
            }
        },
    },
    computed: {
        ...mapState('actionState', ['actions']),
        typeAheadAction() {
            return this.actions[storeAction.initiateSpeakerTypeAheadSearch];
        },
        typeAheadActionPending() {
            return this.typeAheadAction.pending;
        },
    },
};
</script>

<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.filter-options {
    &__typeAhead {
        &-result {
            border: 1px solid $ypo-medium-gray;
            margin-right: 0;
            border-top: none;
            border-radius: 0 0 3px 3px;
            max-height: 130px;
            position: absolute;
            background-color: $white;
            overflow: auto;
            width: 100% !important;
            z-index: 1;

            &--item {
                border-bottom: 1px solid rgba($ypo-medium-gray, 0.7);

                &:hover {
                    background: rgba($ypo-medium-gray, 0.3);
                }

                label {
                    display: block;
                    padding: 7px 5px;
                    font-size: 14px !important;
                    cursor: pointer;
                }
            }

            .overlay {
                position: relative;
            }
        }

        &__input {
            .v-input__slot {
                padding: 0 10px;

                &::before,
                &:after {
                    display: none;
                }
            }
        }
    }
}
</style>
